import {Pipe, PipeTransform} from "@angular/core";
import {DomSanitizer, SafeHtml} from "@angular/platform-browser";
import {ServiceConfig} from "../app/services-config";

@Pipe({
  name: 'safeUrl'
})
export class SafeUrlPipe implements PipeTransform {
  constructor(private sanitizer: DomSanitizer) {
  }

  transform(value: string): SafeHtml {
    if (typeof value === 'string' && value.indexOf(ServiceConfig.baseUrl) === 0) {
      return this.sanitizer.bypassSecurityTrustResourceUrl(value);
    }

    return value;
  }
}



// WEBPACK FOOTER //
// ./src/pipes/safe-url.pipe.ts